/**
 * Defensive urgency-score normaliser.
 *
 * The legacy mirror used to write `risk_score.score` (0–100) into the case's
 * `urgency_score` field. The backend now normalises on write, but old DB rows
 * may still hold values like 68 — so every UI surface that renders
 * "{n}/10" must run through this helper.
 *
 *   normalizeUrgency(68)  -> 7
 *   normalizeUrgency(2.4) -> 2.4
 *   normalizeUrgency(125) -> 10
 *   normalizeUrgency(null)-> 0
 */
export function normalizeUrgency(value) {
  const n = Number(value);
  if (!isFinite(n)) return 0;
  if (n < 0) return 0;
  if (n <= 10) return Math.round(n * 10) / 10;
  if (n <= 100) return Math.round((n / 10) * 10) / 10;
  return 10;
}

/** Format the urgency for display: integer when whole, 1-decimal otherwise. */
export function formatUrgency(value) {
  const v = normalizeUrgency(value);
  return Number.isInteger(v) ? `${v}` : v.toFixed(1);
}
